/**
 * @file Slider.jsx
 * @description Modern hero section with Tailwind CSS
 */

import React from 'react';
import { Link } from 'react-router-dom';
import IMAGES from '../config/images';

const Slider = () => {
  return (
    <section className="relative bg-gradient-to-br from-primary-600 via-primary-700 to-primary-900 text-white overflow-hidden">
      {/* Animated Background Elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute w-96 h-96 bg-primary-400/10 rounded-full -top-20 -left-20 animate-pulse-slow"></div>
        <div className="absolute w-64 h-64 bg-primary-300/10 rounded-full top-40 right-20 animate-bounce-slow"></div>
        <div className="absolute w-80 h-80 bg-primary-500/10 rounded-full bottom-10 left-1/3 animate-pulse-slow"></div>
      </div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-20 md:py-32 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          {/* Logo */}
          <div className="mb-8 animate-fade-in-up flex justify-center">
            <img
              src={IMAGES.logo}
              alt="Metro Plumbing & Heating"
              className="h-24 md:h-32 w-auto drop-shadow-2xl"
            />
          </div>
          
          {/* Main Heading */}
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 animate-fade-in-up">
            Metro Plumbing & Heating
          </h1>
          
          {/* Subtitle */}
          <p className="text-xl md:text-2xl text-blue-100 mb-4 animate-fade-in-up font-medium" style={{ animationDelay: '0.1s' }}>
            Professional Plumbing, Gas & Heating Services Across London
          </p>
          
          {/* Description */}
          <p className="text-base md:text-lg text-blue-50/90 mb-8 max-w-2xl mx-auto animate-fade-in-up" style={{ animationDelay: '0.2s' }}>
            Gas Safe registered engineers providing quality plumbing and heating
            solutions for homes and businesses. Available 24/7 for emergencies.
          </p>

          {/* Badges */}
          <div className="flex flex-wrap justify-center gap-3 mb-10 animate-fade-in-up" style={{ animationDelay: '0.3s' }}>
            <span className="px-4 py-2 bg-green-500/90 backdrop-blur-sm rounded-full text-sm font-semibold shadow-lg hover:bg-green-400 transition-colors duration-300">
              ✓ Gas Safe Registered
            </span>
            <span className="px-4 py-2 bg-red-500/90 backdrop-blur-sm rounded-full text-sm font-semibold shadow-lg hover:bg-red-400 transition-colors duration-300">
              ⚡ 24/7 Emergency Service
            </span>
            <span className="px-4 py-2 bg-blue-500/90 backdrop-blur-sm rounded-full text-sm font-semibold shadow-lg hover:bg-blue-400 transition-colors duration-300">
              💯 Free Quotes
            </span>
            <span className="px-4 py-2 bg-purple-500/90 backdrop-blur-sm rounded-full text-sm font-semibold shadow-lg hover:bg-purple-400 transition-colors duration-300">
              🛡️ Fully Insured
            </span>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row justify-center items-center gap-4 animate-fade-in-up" style={{ animationDelay: '0.4s' }}>
            <Link
              to="/get-quote"
              className="group relative px-8 py-4 bg-white text-primary-600 rounded-lg font-bold text-lg shadow-xl hover:shadow-2xl transform hover:-translate-y-1 transition-all duration-300 overflow-hidden"
            >
              <span className="relative z-10">Get a Free Quote</span>
              <div className="absolute inset-0 bg-gradient-to-r from-primary-50 to-primary-100 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left"></div>
            </Link>
            
            <a
              href="tel:+447379787766"
              className="group relative px-8 py-4 bg-danger-600 text-white rounded-lg font-bold text-lg shadow-xl hover:shadow-2xl transform hover:-translate-y-1 transition-all duration-300 overflow-hidden"
            >
              <span className="relative z-10">📞 Emergency: 07379 787766</span>
              <div className="absolute inset-0 bg-danger-700 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left"></div>
            </a>
          </div>

          {/* Contact Info */}
          <div className="mt-10 text-blue-100 animate-fade-in-up" style={{ animationDelay: '0.5s' }}>
            <p className="text-sm md:text-base">
              <strong className="text-white">Call us:</strong> 07379 787766 |{' '}
              <strong className="text-white">Email:</strong> info@metroplumbingandheating.co.uk
            </p>
          </div>
        </div>
      </div>

      {/* Wave Shape Divider */}
      <div className="absolute bottom-0 left-0 right-0">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 120" className="w-full h-auto">
          <path fill="#ffffff" fillOpacity="1" d="M0,64L48,69.3C96,75,192,85,288,80C384,75,480,53,576,48C672,43,768,53,864,58.7C960,64,1056,64,1152,58.7C1248,53,1344,43,1392,37.3L1440,32L1440,120L1392,120C1344,120,1248,120,1152,120C1056,120,960,120,864,120C768,120,672,120,576,120C480,120,384,120,288,120C192,120,96,120,48,120L0,120Z"></path>
        </svg>
      </div>
    </section>
  );
};

export default Slider;
